function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import Vue from 'vue';
import Notification from './notification.js';
export default Notification;

Notification.newInstance = function (props) {
  var getContainer = props.getContainer,
      top = props.top,
      notificationStyle = props.notificationStyle,
      other = _objectWithoutProperties(props, ["getContainer", "top", "notificationStyle"]);

  var vm = new Vue({
    components: {
      Notification: Notification
    },
    data: function data() {
      return {
        attrs: null,
        listeners: null
      };
    },
    destroyed: function destroyed() {
      var $el = this.$el;
      var parentNode = $el.parentNode;

      if (parentNode) {
        parentNode.removeChild($el);
      }
    },
    render: function render() {
      var h = arguments[0];
      var attrs = this.attrs,
          listeners = this.listeners;

      if (!attrs) {
        return null;
      }

      return h("notification", {
        "props": _objectSpread({}, attrs),
        "on": _objectSpread({}, listeners)
      });
    }
  }).$mount();
  var container = document.body;

  if (typeof getContainer === 'function') {
    var node = getContainer();

    if (node.appendChild) {
      container = node;
    }
  }

  container.appendChild(vm.$el);
  var style;

  if (notificationStyle) {
    style = notificationStyle;

    if (typeof top !== 'undefined') {
      notificationStyle.top = top;
    }
  }

  var attrs = _objectSpread({}, other, {
    notificationStyle: style,
    value: []
  });

  vm.attrs = attrs;
  vm.listeners = {
    input: function input(val) {
      attrs.value = val;
    }
  };
  return {
    notice: function notice(_notice) {
      attrs.value.push(_notice);
    },
    remove: function remove(notice) {
      attrs.value = attrs.value.filter(function (v) {
        return v !== notice;
      });
    },
    destroy: function destroy() {
      vm.$destroy();
    }
  };
};